import { Route, Routes, useNavigate } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { Layout } from "./layout/Layout";
import { Button, Result } from "antd";
import "antd/dist/reset.css";
import { useState } from "react";
import { ContactPage } from "./pages/ContactPage";
import { AboutUsPage } from "./pages/AboutUsPage";
import { InteneraryPage } from "./pages/InteneraryPage";
import { PackagesPage } from "./pages/PackagesPage";

export const App = () => {
  const navigate = useNavigate();
  const [languageId, setLanguageId] = useState(0);
  return (
    <Routes>
      <Route
        element={
          <Layout languageId={languageId} setLanguageId={setLanguageId} />
        }
      >
        <Route path="/" element={<HomePage languageId={languageId} />} />
        <Route
          path="/tours-experiences"
          element={<PackagesPage languageId={languageId} />}
        />
        <Route
          path="/about-us"
          element={<AboutUsPage languageId={languageId} />}
        />
        <Route
          path="/contacts"
          element={<ContactPage languageId={languageId} />}
        />
        <Route
          path="/tour-intenerary"
          element={<InteneraryPage languageId={languageId} />}
        />
      </Route>

      <Route
        path="*"
        element={
          <Result
            status="403"
            title="Page not found"
            subTitle="Sorry, you are not authorized to access this page."
            extra={
              <Button onClick={() => navigate("/")} type="primary">
                Home
              </Button>
            }
          />
        }
      />
    </Routes>
  );
};
